import {lighten} from '@material-ui/core/styles';
import {light}   from 'styles/muiTheme/colors';

export const styles = {
	
	paper : {
		backgroundColor : lighten (light.secondary.main, 0.05),
		padding         : '12px 24px',
		borderRadius    : '0px',
		color           : '#000'
	},

	grid : {
		borderBottom : '1px solid #525252'
	},

	navLink : {
		color    : '#000',
		fontSize : '1rem',
	}
};
